import type { Theme } from './types';
import { themeRegistry } from './registry';
import { readStoredThemeSlug } from './storage';

/**
 * Resolve the initial theme at App mount.
 *
 * Reads the slug persisted in `localStorage['axi.theme']` (see
 * `src/themes/storage.ts`). If a registered theme matches, returns it;
 * otherwise falls back to the registry's default. Pure on the consumer
 * side: it does not write to storage and does not mutate the DOM — those
 * happen in `ThemeProvider`'s `setTheme` and `useEffect`.
 */
export function resolveInitialThemeSlug(): Theme {
  const slug = readStoredThemeSlug();
  if (slug) {
    const found = themeRegistry.get(slug);
    if (found) return found;
  }
  return themeRegistry.defaultTheme();
}